/**
 * Pretitle — the small uppercase label that sits above section titles
 * (e.g. "[ WHAT WE DO ]", "Services", "Legal", "Contact").
 *
 * This is the SINGLE SOURCE OF TRUTH for pretitle typography. To change
 * the look of every pretitle on the site (size, weight, tracking, font),
 * edit only this file.
 *
 * Color and bottom margin are intentionally NOT baked in — they vary per
 * surface (light vs dark section, brand-500 vs brand-400 vs charcoal,
 * different gaps to the heading below) — so callers pass them via
 * `className`.
 *
 * Usage:
 *   <Pretitle className="text-brand-500 mb-5">[ WHAT WE DO ]</Pretitle>
 *   <Pretitle className="text-white/30 mb-6">Services</Pretitle>
 */

import type { ElementType, ReactNode } from 'react'

interface PretitleProps {
  children: ReactNode
  /** Color, margin, alignment utilities. Color is required for visual contrast. */
  className?: string
  /** Render element. Defaults to <p>. Use 'span' inside other text flow. */
  as?: ElementType
}

export default function Pretitle({
  children,
  className = '',
  as: Tag = 'p',
}: PretitleProps) {
  return (
    <Tag
      className={`font-display font-medium uppercase tracking-[0] text-xs md:text-sm ${className}`.trim()}
    >
      {children}
    </Tag>
  )
}
